import useSWR from 'swr';

import { usePrivate } from '@/components/private';
import { enqueueSnackbar } from '@/providers';

import { useGetOrganisationSettingsMessages } from './messages';

export function getOrganisationSettingsCacheKey(
  organisationId: number | null | undefined,
) {
  return `/api/OrganisationSetting/${organisationId}`;
}

export interface useGetOrganisationByEntityIdOptions {
  shouldFetch?: boolean;
}

export function useGetOrganisationSettings(
  organisationId: number | null | undefined,
  options?: useGetOrganisationByEntityIdOptions,
) {
  const mergedOptions: useGetOrganisationByEntityIdOptions = {
    shouldFetch: true,
    ...options,
  };

  const { organisationSettingApi } = usePrivate();

  const results = useSWR(
    organisationSettingApi && mergedOptions.shouldFetch
      ? getOrganisationSettingsCacheKey(organisationId)
      : null,
    () => organisationSettingApi?.apiOrganisationSettingGet(organisationId!),
    {
      onError: (error) => {
        enqueueSnackbar(
          useGetOrganisationSettingsMessages[
            'useGetOrganisationSettings.fetch.unexpectedError'
          ],
          {
            variant: 'error',
          },
        );
        console.error(
          '[BREEDLOGIC] <useGetOrganisationSettings> error fetching organisation settings.',
          error,
        );
      },
    },
  );

  const isLoadingOrValidating =
    results.isLoading || results.isValidating || !organisationSettingApi;

  return { ...results, isLoadingOrValidating };
}
